import { render, staticRenderFns } from "./BankAccountBeneficiary.vue?vue&type=template&id=292e866a&scoped=true"
import script from "./BankAccountBeneficiary.vue?vue&type=script&lang=js"
export * from "./BankAccountBeneficiary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292e866a",
  null
  
)

export default component.exports